import {RESELLER_INVOICE_PROJECTION_IMPORT} from '../../Api/resources/endPoint';
import { serviceName } from '../../Api/resources/serviceConstants';

export const fetchResellerImport = ({userInfo, importData}) => {
  const requestPayload = {
    userInfo,
    importData,
  };
  return {
    url: RESELLER_INVOICE_PROJECTION_IMPORT,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestPayload,
    service: serviceName.PROJECT_MS,
  };
};
